import AuthLayout from '@src/router/layouts/auth/layout.vue'
import ROUTE from '@src/constants/route-constants.js'
import { getDefaultRoute } from '@utils/generalUtil'
import store from '@src/state/store'

const userRole = store?.getters['layout/userRole']
const selectedCampus = store?.state?.layout?.currentCampusScope || ''
const SelectedSection = store?.state?.layout?.currentSectionScope || ''
const redirectRoute = getDefaultRoute(userRole, selectedCampus, SelectedSection)
export default [
  {
    path: '/signin',
    name: 'login',
    component: () => import('@views/auth/signin.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let loggedIn = localStorage.getItem('auth.currentUser') || null
        // If the user is already logged in
        if (loggedIn) {
          // Redirect to the home page instead
          next({
            name: 'default',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },

  {
    path: '/unsubscribe',
    name: 'user-notification-preferences',
    component: () =>
      import(
        '@/src/router/views/settings/notification-settings/userNotificationPreferencesView.vue'
      ),
  },

  {
    path: '/',
    meta: {
      authRequired: false,
    },
    component: AuthLayout,
    children: [
      {
        path: '',
        name: 'home',
        beforeEnter(routeTo, routeFrom, next) {
          let loggedIn = localStorage.getItem('auth.currentUser') || null
          // If the user is already logged in
          if (loggedIn) {
            // Redirect to the home page instead
            next({
              name: redirectRoute,
            })
          } else next({ name: 'login' })
        },
      },
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        component: () => import('@src/router/views/privacy-policy/privacy-policy.vue'),
      },
      {
        path: '/setup-slider',
        name: 'setup-slider',
        component: () => import('@views/setup-slider/SetupSlider.vue'),
        beforeEnter(routeTo, routeFrom, next) {
          let stats = JSON.parse(localStorage.getItem('institutesCounts')) || null
          if (!stats || stats.campuses_count) {
            next({
              name: redirectRoute,
            })
          } else next()
        },
      },
      {
        path: '',
        name: 'default',
        redirect: { name: ROUTE?.DASHBOARD?.PATH },
        meta: {
          authRequired: true,
        },
        component: () => import('@src/router/layouts/defaultLayout.vue'),
        children: [
          // Passes through main layout and with default left bar
          {
            path: '',
            component: () => import('@/src/router/layouts/main-layout/mainLayout.vue'),
            children: [
              // Admin Dashboard
              {
                path: ROUTE?.DASHBOARD?.PATH,
                name: ROUTE?.DASHBOARD?.ROUTE_NAME,
                component: () => import('@views/dashboard/DashboardView.vue'),
              },
              /* User Profile*/
              {
                path: 'myprofile',
                name: 'my-profile',
                component: () => import('@src/router/views/my-profile/MyProfileView.vue'),
              },
              /* NOTICE BOARD */
              {
                path: 'notice-board',
                redirect: { name: 'notice-board-view' },
                component: () => import('@src/router/layouts/notice-board/layout.vue'),
                children: [
                  {
                    path: 'view',
                    name: 'notice-board-view',
                    component: () => import('@src/router/views/notice-board/NoticeBoardView.vue'),
                  },
                  {
                    path: 'labels',
                    name: 'notice-board-labels',
                    component: () =>
                      import('@/src/router/views/notice-board/post-labels/PostLabelsView.vue'),
                  },
                ],
              },

              /* Quick Actions */
              {
                path: 'quick-actions',
                name: 'quick-actions',
                component: () => import('@views/quick-actions/QuickActions.vue'),
              },
              /* PERIOD Attendance */
              {
                path: 'attendance',
                redirect: { name: 'section-attendance' },
                component: () => import('@/src/router/layouts/attendance/layout.vue'),
                children: [
                  {
                    path: 'daily-student-attendance',
                    name: 'daily-student-attendance',
                    component: () =>
                      import(
                        '@/src/router/views/attendance/daily-attendance/student-daily-attendance/DailyStudentAttendanceView.vue'
                      ),
                  },
                  {
                    path: 'daily-staff-attendance',
                    name: 'daily-staff-attendance',
                    component: () =>
                      import(
                        '@/src/router/views/attendance/daily-attendance/staff-daily-attendance/DailyStaffAttendanceView.vue'
                      ),
                  },
                  {
                    path: 'section',
                    name: 'section-attendance',
                    redirect: { name: 'student-section-attendance' },
                    component: () => import('@src/router/layouts/attendance/section/layout.vue'),
                    children: [
                      {
                        path: 'students',
                        name: 'student-section-attendance',
                        component: () =>
                          import(
                            '@/src/router/views/attendance/section-attendance/student/StudentSectionAttendanceView.vue'
                          ),
                      },
                      {
                        path: 'students/:id/detail',
                        name: 'student-section-attendance-detail',
                        component: () =>
                          import(
                            '@/src/router/views/attendance/section-attendance/student/SectionStudentAttendanceDetail.vue'
                          ),
                      },
                      {
                        path: 'teacher',
                        name: 'teacherCheckInOut',
                        component: () =>
                          import(
                            '@/src/router/views/attendance/staff-check-in-out/staffCheckInOut.vue'
                          ),
                      },
                    ],
                  },
                  {
                    path: 'campus',
                    name: 'campus-attendance',
                    redirect: { name: 'student-campus-attendance' },
                    component: () => import('@/src/router/layouts/attendance/section/layout.vue'),
                    children: [
                      {
                        path: 'students',
                        name: 'student-campus-attendance',
                        component: () =>
                          import(
                            '@/src/router/views/attendance/campus-attendance/CampusStudentAttendanceView.vue'
                          ),
                      },
                      {
                        path: 'staff',
                        name: 'staff-campus-attendance',
                        component: () =>
                          import('@/src/router/views/campus-attendance/StaffAttendanceView.vue'),
                      },
                    ],
                  },
                  {
                    path: 'period',
                    redirect: { name: 'students-period-attendance' },
                    name: 'period-attendance',
                    component: () => import('@/src/router/layouts/attendance/section/layout.vue'),
                    children: [
                      {
                        path: 'students',
                        name: 'students-period-attendance',
                        component: () =>
                          import(
                            '@/src/router/views/attendance/period-attendance/student/StudentPeriodAttendanceView.vue'
                          ),
                      },
                      {
                        path: 'students/:id/detail',
                        name: 'students-period-attendance-details',
                        component: () =>
                          import(
                            '@views/attendance/period-attendance/student/StudentPeriodAttendanceDetailView.vue'
                          ),
                      },
                    ],
                  },
                ],
              },
              // Time Table
              {
                path: '/time-table',
                redirect: { name: 'time-table-automator' },
                component: () => import('@/src/router/views/time-table/layout.vue'),
                children: [
                  {
                    path: 'automator',
                    name: 'time-table-automator',
                    component: () =>
                      import(
                        '@/src/router/views/time-table/time-table-automator/TimeTableAutomatorView.vue'
                      ),
                  },
                  {
                    path: 'current',
                    name: 'current-time-table',
                    component: () =>
                      import('@views/time-table/current-time-table/CurrentTimeTableView.vue'),
                  },
                  {
                    path: 'my-timetable',
                    name: 'my-timetable',
                    component: () =>
                      import('@views/time-table/current-time-table/CurrentTimeTableView.vue'),
                  },
                  {
                    path: 'staff-birthdays',
                    name: 'staff-birthdays',
                    component: () =>
                      import(
                        '@src/router/views/time-table/current-time-table/StaffBirthdayView.vue'
                      ),
                  },
                  {
                    path: 'student-birthdays',
                    name: 'student-birthdays',
                    component: () =>
                      import(
                        '@src/router/views/time-table/current-time-table/StudentBirthdayView.vue'
                      ),
                  },
                  {
                    path: 'lesson-planner',
                    name: 'lesson-planner',
                    component: () =>
                      import('@/src/router/views/lesson-planner/lesson-planner/LessonPlanner.vue'),
                  },
                ],
              },
              // Assignment Types
              {
                path: '/assignment',
                redirect: { name: 'assignmens-view' },
                component: () => import('@src/router/layouts/assignment/assignment-layout.vue'),
                children: [
                  {
                    path: 'types',
                    name: 'assignment-types',
                    component: () =>
                      import('@src/router/views/assignments/types/AssignmentTypesView.vue'),
                  },
                  {
                    path: 'view',
                    name: 'assignmens-view',
                    component: () => import('@views/assignments/assignments/AssignmentsView.vue'),
                  },
                  {
                    path: ':id/detail',
                    name: 'assignmens-detail-view',
                    component: () =>
                      import('@views/assignments/assignments/detail-view/AssignmentDetailView.vue'),
                  },
                ],
              },

              // Syllabus Manager
              {
                path: '/syllabus',
                redirect: { name: 'subjects' },
                component: () => import('@/src/router/views/topics/layout.vue'),
                children: [
                  {
                    path: 'template',
                    name: 'subject-syllabus-template-course',
                    component: () => import('@views/syllabus/template/CourseProviderView.vue'),
                  },
                  {
                    path: 'view',
                    name: 'subject-syllabus-template',
                    component: () => import('@views/syllabus/template/SyllabusTemplateView.vue'),
                  },
                  {
                    path: 'detail',
                    name: 'detail',
                    redirect: { name: 'subject-syllabus-template' },
                  },
                  {
                    path: 'detail/:id/view',
                    name: 'subject-syllabus-template-detail-view',
                    component: () => import('@views/syllabus/template/DetailView.vue'),
                  },
                  {
                    path: 'import/:id',
                    name: 'subject-syllabus-template-import',
                    component: () => import('@views/syllabus/template/ImportTemplateView.vue'),
                  },

                  {
                    path: 'subjects',
                    name: 'subjects',
                    component: () => import('@/src/router/views/subjects/SubjectsView.vue'),
                  },
                  {
                    path: 'chapters',
                    name: 'chapters',
                    component: () =>
                      import('@/src/router/views/lesson-planner/chapter/ChaptersView.vue'),
                  },
                  {
                    path: 'topics',
                    name: 'topics',
                    component: () => import('@/src/router/views/topics/TopicsView.vue'),
                  },
                  {
                    path: 'lessons',
                    name: 'lessons',
                    component: () =>
                      import('@/src/router/views/lesson-planner/lesson/LessonsView.vue'),
                  },
                ],
              },
              {
                path: '/subject-syllabus-template',
                name: 'subject-syllabus-template-layout',
                redirect: { name: 'subject-syllabus-template' },
                component: () => import('@src/router/layouts/syllabus-template/layout.vue'),
                children: [],
              },
              // Expense Manager
              {
                path: 'expense',
                name: 'expense',
                redirect: { name: 'expenses' },
                component: () => import('@src/router/layouts/expense/expense-layout.vue'),
                children: [
                  {
                    path: 'categories',
                    name: 'categories',
                    component: () =>
                      import(
                        '@/src/router/views/expense-manager/categories/ExpenseCategoryView.vue'
                      ),
                  },
                  {
                    path: 'expenses',
                    name: 'expenses',
                    component: () => import('@src/router/views/expense-manager/ExpensesView.vue'),
                  },
                ],
              },
              // Pickup Manager
              {
                path: 'pickup-manager',
                name: 'pickup-manager',
                redirect: { name: 'facility-active-request' },
                component: () => import('@src/router/layouts/pickup/layout.vue'),
                children: [
                  {
                    path: 'active',
                    name: 'facility-active-request',
                    component: () =>
                      import('@src/router/views/pickup/pickup-facility/ActiveRequestsView.vue'),
                  },
                  {
                    path: 'all',
                    name: 'facility-all-requests',
                    component: () =>
                      import('@src/router/views/pickup/pickup-facility/AllRequestsView.vue'),
                  },
                  {
                    path: ':id/detail',
                    name: 'request-details',
                    component: () => import('@views/pickup/misc/RequestDetailView.vue'),
                  },
                ],
              },

              // Lesson Types
              {
                path: 'lesson-types',
                name: 'lesson-types',
                component: () => import('@src/router/views/lesson/LessonTypesView.vue'),
              },
              // Support Query
              {
                path: '/support-query',
                redirect: { name: 'support-query-types' },
                component: () => import('@/src/router/layouts/support-query/layout.vue'),
                children: [
                  {
                    path: 'types',
                    name: 'support-query-types',
                    component: () =>
                      import(
                        '@src/router/views/support-query/support-query-types/supportQueryTypesView.vue'
                      ),
                  },
                  {
                    path: 'queries',
                    name: 'support-query',
                    component: () =>
                      import('@/src/router/views/support-query/support-query/supportQueryview.vue'),
                  },
                  {
                    path: 'queries/:id/conversation',
                    name: 'support-query-conversation',
                    component: () =>
                      import(
                        '@/src/router/views/support-query/support-query/supportQueryConversationView.vue'
                      ),
                  },
                ],
              },

              // Exam Planner
              {
                path: '/exam-planner',
                redirect: { name: 'exams' },
                component: () => import('@/src/router/layouts/exam-planner/layout.vue'),
                children: [
                  {
                    path: 'exams',
                    name: 'exams',
                    component: () => import('@views/exam-planner/exams/ExamsView.vue'),
                  },
                  {
                    path: 'exams/:id/detail',
                    name: 'exams-detail-view',
                    component: () => import('@src/router/views/exam-planner/exams/DetailView.vue'),
                  },
                  {
                    path: 'types',
                    name: 'exam-types',
                    component: () => import('@/src/router/views/exam-planner/types/ExamTypes.vue'),
                  },
                  {
                    path: 'exams/:examId/exam-result',
                    name: 'exam-result',
                    component: () => import('@/src/router/views/exam-planner/ExamResult.vue'),
                  },
                  {
                    path: 'exams/:id/detail/:subjectId/MarkDetail',
                    name: 'exam-result-view',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/exam-subject-result/ResultDetailView.vue'
                      ),
                  },
                ],
              },
              // Fee Manager
              {
                path: '/fee',
                name: 'fees',
                redirect: { name: 'receivable' },
                component: () => import('@src/router/layouts/finance-layout/fees-layout.vue'),
                children: [
                  {
                    path: 'receivable',
                    name: 'receivable',
                    component: () =>
                      import('@/src/router/views/finance/fees/receivable/Receivable.vue'),
                  },
                  {
                    path: 'accept-payment',
                    name: 'accept-payment',
                    component: () =>
                      import('@views/finance/fees/accept-payment/AcceptPaymentView.vue'),
                  },
                  {
                    path: 'payable',
                    name: 'payable',
                    component: () =>
                      import('@/src/router/views/finance/fees/receivable/Receivable.vue'),
                  },
                  {
                    path: 'types',
                    name: 'fee-types',
                    component: () => import('@/src/router/views/finance/fees/types/Fee-Types.vue'),
                  },
                  {
                    path: 'monthly-fee-generator',
                    name: 'monthly-fee-generator',
                    component: () =>
                      import(
                        '@/src/router/views/finance/fees/monthly-fee-generator/MonthlyFeeGeneratorView.vue'
                      ),
                  },

                  {
                    path: 'received',
                    name: 'received',
                    component: () =>
                      import('@/src/router/views/finance/fees/received/Received.vue'),
                  },
                  {
                    path: 'paid',
                    name: 'student-paid',
                    component: () =>
                      import('@/src/router/views/finance/fees/received/Received.vue'),
                  },
                  {
                    path: ':id/detail',
                    name: 'fee-details',
                    component: () => import('@views/finance/fees/FeeDetailView.vue'),
                  },
                  {
                    path: 'discount-types',
                    name: 'discount-types',
                    component: () =>
                      import('@/src/router/views/finance/fees/discount/DiscountTypes.vue'),
                  },
                  {
                    path: 'student-discounts',
                    name: 'student-discounts',
                    component: () =>
                      import(
                        '@/src/router/views/finance/fees/discount/StudentDiscountListView.vue'
                      ),
                  },
                  {
                    path: 'student-discounts/:id/detail',
                    name: 'student-discounts-detail',
                    component: () =>
                      import(
                        '@/src/router/views/finance/fees/discount/StudentDiscountDetailView.vue'
                      ),
                  },
                  {
                    path: 'section',
                    name: 'section',
                    component: () => import('@views/finance/fees/section-fee/SectionFeeView.vue'),
                  },
                  {
                    path: 'section/:id/details',
                    name: 'section-fee-details',
                    component: () =>
                      import('@views/finance/fees/section-fee/detail-view/DetailedView.vue'),
                  },
                ],
              },
              // Exam Result
              {
                path: '/grades-manager',
                redirect: { name: 'section-result' },
                component: () => import('@src/router/layouts/grades-manager/layout.vue'),
                children: [
                  {
                    path: 'non-gpa',
                    name: 'non-gpa-grading-structure',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/grades-manager/NonGPAGradingStructureView.vue'
                      ),
                  },
                  {
                    path: 'non-gpa/:id/detail',
                    name: 'non-gpa-grading-structure-detail-view',
                    component: () =>
                      import('@src/router/views/exam-planner/grades-manager/NonGPADetailView.vue'),
                  },
                  {
                    path: 'gpa',
                    name: 'gpa-grading-structure',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/GPAGradingStructureView.vue'
                      ),
                  },
                  {
                    path: 'gpa/:id/detail',
                    name: 'gpa-grading-structure-detail-view',
                    component: () =>
                      import('@/src/router/views/exam-planner/grades-manager/GPADetailView.vue'),
                  },

                  {
                    path: 'section-result',
                    name: 'section-result',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionExamResultView.vue'
                      ),
                  },
                  {
                    path: 'final-result',
                    name: 'final-result',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionExamResultView.vue'
                      ),
                  },
                  {
                    path: 'performance-chart',
                    name: 'performance-chart',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/StudentPerformanceView.vue'
                      ),
                  },

                  {
                    path: 'final-result/:id/detail',
                    name: 'final-result-detail',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionResultDetailView.vue'
                      ),
                  },
                  {
                    path: 'final-result/:id/view/:resultId/final-result',
                    name: 'final-result-detail-view',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SingleStudentResultView.vue'
                      ),
                  },
                  {
                    path: 'section-result/:id/detail',
                    name: 'section-result-detail-view',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionResultDetailView.vue'
                      ),
                  },
                  {
                    path: 'section-result/:id/view',
                    name: 'section-result-view',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/ViewSectionResultDetail.vue'
                      ),
                  },
                  {
                    path: 'section-result/:id/view/:resultId/student-result',
                    name: 'student-result-detail',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SingleStudentResultView.vue'
                      ),
                  },

                  {
                    path: 'subject-result',
                    name: 'subject-result',
                    component: () =>
                      import(
                        '@views/exam-planner/generate-subject-exam-result/SubjectExamResultsView.vue'
                      ),
                  },
                  {
                    path: 'subject-result/:id/detail',
                    name: 'subject-result-detail',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/generate-subject-exam-result/DetailView.vue'
                      ),
                  },
                  // Duplicate route with different path as serverd from different places
                  {
                    path: 'subject-result/:id/detail/view',
                    name: 'subject-resul-detail-view',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/generate-subject-exam-result/ViewSubjectExamResultDetail.vue'
                      ),
                  },
                  {
                    path: 'subject-result/:id/view',
                    name: 'subject-result-view',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/generate-subject-exam-result/ViewSubjectExamResultDetail.vue'
                      ),
                  },
                ],
              },
              // Users
              {
                path: '/users',
                name: 'users',
                redirect: { name: 'pickup-person' },
                component: () => import('@src/router/layouts/users/users-layout.vue'),
                children: [
                  /* All Users View*/
                  {
                    path: 'all-users',
                    name: 'all-users',
                    component: () => import('@src/router/views/all-users/AllUserView.vue'),
                  },
                  /* Super Admin View */
                  {
                    path: 'super-admin',
                    name: 'super-admin',
                    component: () => import('@src/router/views/super-admin/SuperAdminView.vue'),
                  },
                  //pickup member
                  {
                    path: 'pickup-person',
                    name: 'pickup-person',
                    component: () => import('@views/pickup/pickup-person/PickupIndiviualsView.vue'),
                  },
                  //guardian
                  {
                    path: 'guardians',
                    name: 'guardians',
                    component: () => import('@src/router/views/guardians/GuardiansView.vue'),
                  },
                  //campus-admin
                  {
                    path: 'campus-admin',
                    name: 'campus-admin',
                    component: () => import('@src/router/views/campus-admin/CampusAdminView.vue'),
                  },
                  // Staff
                  {
                    path: 'staff',
                    name: 'staff',
                    component: () => import('@/src/router/views/staff/StaffView.vue'),
                  },
                  // Students
                  {
                    path: 'students',
                    name: 'students',
                    component: () => import('@/src/router/views/student/StudentsView.vue'),
                  },
                  {
                    path: 'teacher-students',
                    name: 'teacher-students',
                    component: () => import('@/src/router/views/student/StudentsView.vue'),
                  },
                  // Teachers
                  {
                    path: 'teachers',
                    name: 'teachers',
                    component: () => import('@/src/router/views/teacher/TeacherView.vue'),
                  },
                ],
              },

              // Campuses
              {
                path: '/campuses',
                name: 'campuses',
                component: () => import('@src/router/views/campuses/CampusesView.vue'),
              },

              // Rooms
              {
                path: '/rooms',
                name: 'rooms',
                component: () => import('@/src/router/views/rooms/RoomView.vue'),
              },

              // Classes
              {
                path: '/classes',
                name: 'classes',
                component: () => import('@/src/router/views/classes/classes.vue'),
              },
              // Sections
              {
                path: '/sections',
                name: 'sections',
                component: () => import('@src/router/views/sections/SectionsView.vue'),
              },
              // AllNotification
              {
                path: 'notifications',
                name: 'all-notifications',
                component: () => import('@/src/modules/header/allNotifications.vue'),
              },
              {
                path: 'announcements',
                name: 'all-announcements',
                component: () => import('@/src/modules/header/allAnnouncement.vue'),
              },
              // Single Notification
              {
                path: '/single-notification',
                name: 'single-notification',
                component: () => import('@/src/router/views/notifications/AnnouncementView.vue'),
              },

              {
                path: 'settings',
                redirect: { name: 'general-settings' },
                component: () => import('@views/settings/layout.vue'),
                children: [
                  {
                    path: 'notification',
                    name: 'notificationSettings',
                    component: () =>
                      import('@views/settings/notifications/notificationSettings.vue'),
                  },
                ],
              },
              /* NOTIFICATIONS LAYOUT */
              {
                path: 'notification',
                redirect: { name: 'announcement' },
                component: () => import('@/src/router/views/notifications/layout.vue'),
                children: [
                  {
                    path: 'announcement',
                    name: 'announcement',
                    component: () =>
                      import('@/src/router/views/notifications/AnnouncementView.vue'),
                  },
                  {
                    path: 'announcement/:announcementId/detail',
                    name: 'announcement-detail',
                    component: () =>
                      import('@/src/router/views/notifications/DetailView/AnnouncementDetail.vue'),
                  },
                  {
                    path: 'announcement-types',
                    name: 'announcement-types',
                    component: () =>
                      import('@/src/router/views/occasions/AnnouncementTypesView.vue'),
                  },
                ],
              },
              /* Registration Process */
              {
                path: 'registration',
                redirect: { name: 'registration-list' },
                component: () => import('@router/layouts/registration-process/Layout.vue'),
                children: [
                  {
                    path: 'list',
                    name: 'registration-list',
                    component: () =>
                      import('@views/registration-process/registrations/RegistrationsView.vue'),
                  },
                  {
                    path: 'form-generator',
                    name: 'form-generator',
                    component: () =>
                      import('@views/registration-process/form-generator/FormGeneratorView.vue'),
                  },
                  {
                    path: 'form/:title',
                    name: 'form',
                    component: () =>
                      import(
                        '@views/registration-process/form-generator/registration-types/Form.vue'
                      ),
                  },
                ],
              },
              /* SALARY LAYOUT */
              {
                path: 'salary-manager',
                redirect: { name: 'salaries' },
                component: () => import('@/src/router/views/salary-manager/layout.vue'),
                children: [
                  {
                    path: 'my-salary',
                    name: 'my-salary',
                    component: () =>
                      import('@/src/router/views/salary-manager/UserSalaryHistory.vue'),
                  },
                  {
                    path: 'salaries/:id/detail',
                    name: 'user-salary-detail',
                    component: () =>
                      import('@/src/router/views/salary-manager/UserSalaryHistoryDetail.vue'),
                  },
                  {
                    path: 'my-salary/:id/detail',
                    name: 'my-salary-detail',
                    component: () =>
                      import('@/src/router/views/salary-manager/UserSalaryHistoryDetail.vue'),
                  },
                  {
                    path: 'salaries',
                    name: 'salaries',
                    component: () => import('@/src/router/views/salary-manager/Salaries.vue'),
                  },
                  {
                    path: 'allowence-type',
                    name: 'allowence-type',
                    component: () => import('@/src/router/views/salary-manager/AllowenceType.vue'),
                  },
                  {
                    path: 'deduction-type',
                    name: 'deduction-type',
                    component: () => import('@/src/router/views/salary-manager/DeductionType.vue'),
                  },
                  {
                    path: 'bonuses-type',
                    name: 'bonuses-type',
                    component: () => import('@/src/router/views/salary-manager/BonusesType.vue'),
                  },
                  {
                    path: 'extra-working-unit',
                    name: 'extra-working-unit',
                    component: () =>
                      import('@src/router/views/salary-manager/ExtraWorkingUnit.vue'),
                  },
                  {
                    path: 'salary-generator',
                    name: 'salary-generator',
                    component: () =>
                      import('@/src/router/views/salary-manager/SalaryGenerator.vue'),
                  },
                  {
                    path: 'salary-generator/:id/salary-template',
                    name: 'salary-template',
                    component: () => import('@/src/router/views/salary-manager/SalaryTemplate.vue'),
                  },
                ],
              },
            ],
          },
          {
            path: '/users/:id',
            component: () =>
              import('@/src/router/layouts/roles-and-access-layout/roles-and-access-layout.vue'),
            children: [
              {
                path: 'access',
                name: 'roles-and-acccess-management',
                component: () => import('@/src/components/RolesAndAccessManagement.vue'),
              },
            ],
          },
          /* Student Mode */
          {
            path: '/student/:student_id',
            redirect: { name: 'student-profile-mode' },
            component: () =>
              import('@/src/router/layouts/profile-layout/student-profile-layout.vue'),
            children: [
              {
                path: 'profile',
                name: 'student-profile-mode',
                component: () => import('@router/views/student/profile/profile.vue'),
              },
              {
                path: 'dashboard',
                name: 'student-profile-dashboard',
                component: () => import('@router/views/student/profile/dashboard.vue'),
              },
              {
                path: 'fee',
                redirect: { name: 'student-fee-receivable' },
                component: () => import('@router/layouts/profile-layout/student-fee-layout.vue'),
                children: [
                  {
                    path: 'payable',
                    name: 'student-fee-receivable',
                    component: () => import('@router/views/student/profile/receivable.vue'),
                  },
                  {
                    path: 'paid',
                    name: 'student-fee-received',
                    component: () => import('@router/views/student/profile/received.vue'),
                  },
                ],
              },

              {
                path: 'student-attendance',
                redirect: { name: 'student-view-section-attendance' },
                component: () =>
                  import('@router/layouts/profile-layout/student-attendance-layout.vue'),
                children: [
                  {
                    path: 'section',
                    name: 'student-view-section-attendance',
                    component: () =>
                      import(
                        '@/src/router/views/attendance/section-attendance/student/StudentSectionAttendanceView.vue'
                      ),
                  },
                  {
                    path: 'campus',
                    name: 'student-view-campus-attendance',
                    component: () =>
                      import(
                        '@/src/router/views/attendance/campus-attendance/CampusStudentAttendanceView.vue'
                      ),
                  },
                  {
                    path: 'period',
                    name: 'student-view-period-attendance',
                    component: () =>
                      import(
                        '@/src/router/views/attendance/period-attendance/student/StudentPeriodAttendanceView.vue'
                      ),
                  },
                ],
              },
              {
                path: 'time-table',
                redirect: { name: 'student-current-time-table' },
                component: () =>
                  import('@router/layouts/profile-layout/student-time-table-layout.vue'),
                children: [
                  {
                    path: 'current',
                    name: 'student-current-time-table',
                    component: () =>
                      import('@views/time-table/current-time-table/CurrentTimeTableView.vue'),
                  },
                ],
              },
              {
                path: 'exams',
                redirect: { name: 'student-exam-view' },
                component: () => import('@router/layouts/profile-layout/student-exam-layout.vue'),
                children: [
                  {
                    path: 'exam',
                    name: 'student-exam-view',
                    component: () => import('@views/exam-planner/exams/ExamsView.vue'),
                  },
                  {
                    path: 'exam/:id/detail',
                    name: 'student-exams-detail-view',
                    component: () => import('@src/router/views/exam-planner/exams/DetailView.vue'),
                  },
                  {
                    path: 'subject-result',
                    name: 'student-subject-result',
                    component: () =>
                      import(
                        '@views/exam-planner/generate-subject-exam-result/SubjectExamResultsView.vue'
                      ),
                  },
                  {
                    path: 'subject-result/:id/detail',
                    name: 'student-subject-result-detail',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/generate-subject-exam-result/DetailView.vue'
                      ),
                  },
                  {
                    path: 'subject-result/:id/view',
                    name: 'student-subject-result-view',
                    component: () =>
                      import(
                        '@src/router/views/exam-planner/generate-subject-exam-result/ViewSubjectExamResultDetail.vue'
                      ),
                  },
                  {
                    path: 'final-result',
                    name: 'student-final-result',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionExamResultView.vue'
                      ),
                  },
                  {
                    path: 'student-performance',
                    name: 'student-performance-result',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/StudentPerformanceView.vue'
                      ),
                  },
                  {
                    path: 'final-result/:id/detail',
                    name: 'student-final-result-detail',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SectionResultDetailView.vue'
                      ),
                  },
                  {
                    path: 'final-result/:id/view',
                    name: 'student-final-result-view',
                    component: () =>
                      import(
                        '@/src/router/views/exam-planner/grades-manager/SingleStudentResultView.vue'
                      ),
                  },
                ],
              },
              {
                path: 'student-syllabus',
                redirect: { name: 'subjects' },

                component: () =>
                  import('@router/layouts/profile-layout/student-syllabus-manager-layout.vue'),

                children: [
                  {
                    path: 'subjects',
                    name: 'student-subjects',
                    component: () => import('@/src/router/views/subjects/SubjectsView.vue'),
                  },
                  {
                    path: 'chapters',
                    name: 'student-chapters',
                    component: () =>
                      import('@/src/router/views/lesson-planner/chapter/ChaptersView.vue'),
                  },
                  {
                    path: 'topics',
                    name: 'student-topics',
                    component: () => import('@/src/router/views/topics/TopicsView.vue'),
                  },
                  {
                    path: 'lessons',
                    name: 'student-lessons',
                    component: () =>
                      import('@/src/router/views/lesson-planner/lesson/LessonsView.vue'),
                  },
                ],
              },
            ],
          },
          /* CONTROL PANEL */
          {
            path: 'control-panel',
            name: 'control-panel',
            component: () => import('@/src/router/layouts/control-panel/layout.vue'),
            redirect: { name: 'control-panel-settings' },
            children: [
              /* OWNERSHIP */
              {
                path: 'ownership',
                name: 'ownership',
                component: () => import('@src/router/views/transfer_ownership/OwnerShipView.vue'),
              },
              {
                path: 'billing-payment',
                name: 'billing-payment',
                component: () => import('@/src/router/views/payment-methods/billingPayment.vue'),
              },
              /* PAYMENT METHODS */
              {
                path: 'payment-methods',
                name: 'payment-methods',
                component: () =>
                  import('@/src/router/views/payment-methods/PaymentMethodsView.vue'),
              },
              {
                path: 'features-manager',
                name: 'features-manager',
                component: () => import('@src/router/views/feature-manager/featureManagerVeiw.vue'),
              },
              /* ADD-ONS */
              {
                path: 'add-ons',
                name: 'add-ons',
                redirect: { name: 'email-add-ons' },
                component: () => import('@router/layouts/add-ons/layout.vue'),
                children: [
                  {
                    path: 'sms',
                    name: 'sms-add-ons',
                    component: () =>
                      import('@src/router/views/settings/ad-ons/SMS/SMSAddOnsview.vue'),
                  },
                  {
                    path: 'email',
                    name: 'email-add-ons',
                    component: () =>
                      import('@/src/router/views/settings/ad-ons/Email/EmailAdOnsview.vue'),
                  },
                  {
                    path: 'email/:id/detail',
                    name: 'email-provider-detail-page',
                    component: () =>
                      import('@src/router/views/settings/ad-ons/Email/EmailAdOnDetailView.vue'),
                  },
                  {
                    path: 'sms/:id/detail',
                    name: 'sms-provider-detail-page',
                    component: () =>
                      import('@src/router/views/settings/ad-ons/SMS/SMSAddOnsDetailView.vue'),
                  },
                ],
              },
              /* Features Settings */
              {
                path: 'features',
                redirect: { name: 'pickup-feature-settings' },
                component: () => import('@src/router/layouts/features-settings/layout.vue'),
                children: [
                  {
                    path: 'pickup',
                    name: 'pickup-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/pickupfeature.vue'),
                  },
                  {
                    path: 'campus-attendance',
                    name: 'campus-attendance-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/CampusAttendanceFeature.vue'
                      ),
                  },
                  {
                    path: 'period-attendance',
                    name: 'period-attendance-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/PeriodAttendanceFeature.vue'
                      ),
                  },
                  {
                    path: 'section-attendance-feature-settings',
                    name: 'section-attendance-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/SectionAttendanceFeature.vue'
                      ),
                  },
                  {
                    path: 'syllabus-automator',
                    name: 'syllabus-automator-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/SyllabusAutomatorFeature.vue'
                      ),
                  },
                  {
                    path: 'fee',
                    name: 'fee-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/FeeFeature.vue'),
                  },
                  {
                    path: 'staff',
                    name: 'staff-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/StaffFeature.vue'),
                  },
                  {
                    path: 'syllabus',
                    name: 'syllabus-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/SyllabusFeature.vue'
                      ),
                  },
                  {
                    path: 'schedule',
                    name: 'schedule-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/ScheduleFeature.vue'
                      ),
                  },
                  {
                    path: 'lesson-planner',
                    name: 'lesson-planner-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/LessonPlannerFeature.vue'
                      ),
                  },
                  {
                    path: 'teacher',
                    name: 'teacher-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/TeacherFeature.vue'),
                  },
                  {
                    path: 'exam',
                    name: 'exam-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/ExamFeature.vue'),
                  },
                  {
                    path: 'time-table',
                    name: 'time-table-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/TimeTableFeature.vue'
                      ),
                  },
                  {
                    path: 'class',
                    name: 'class-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/ClassFeature.vue'),
                  },
                  {
                    path: 'support-query',
                    name: 'support-query-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/SupportQueryFeature.vue'
                      ),
                  },
                  {
                    path: 'section',
                    name: 'section-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/SectionFeature.vue'),
                  },
                  {
                    path: 'daily-student-attendance-feature-settings',
                    name: 'daily-student-attendance-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/DailySectionAttendanceFeature.vue'
                      ),
                  },
                  {
                    path: 'exam-planner',
                    name: 'exam-planner-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/ExamPlannerFeature.vue'
                      ),
                  },
                  {
                    path: 'pickup-person',
                    name: 'pickup-person-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/PickupPersonFeature.vue'
                      ),
                  },
                  {
                    path: 'student',
                    name: 'student-feature-settings',
                    component: () =>
                      import('@src/router/views/control-panel/feature-settings/StudentFeature.vue'),
                  },
                  {
                    path: 'guardian',
                    name: 'guardian-feature-settings',
                    component: () =>
                      import(
                        '@src/router/views/control-panel/feature-settings/GuardianFeature.vue'
                      ),
                  },
                ],
              },

              /* System Settings */
              {
                path: 'system',
                name: 'system',
                redirect: {
                  name: 'general-settings',
                },
                component: () => import('@/src/router/views/settings/system-settings/layout.vue'),
                children: [
                  {
                    path: 'general',
                    name: 'general-settings',
                    component: () =>
                      import(
                        '@views/settings/system-settings/features-settings/FeaturesGeneralSettings.vue'
                      ),
                  },
                  {
                    path: 'site',
                    name: 'site-settings',
                    component: () =>
                      import('@/src/router/views/settings/system-settings/siteSetting.vue'),
                  },
                  {
                    path: 'contact-settings',
                    name: 'contact-settings',
                    component: () =>
                      import('@/src/router/views/settings/system-settings/contactSettings.vue'),
                  },
                  {
                    path: 'billing',
                    name: 'billing-settings',
                    component: () =>
                      import('@/src/router/views/settings/system-settings/billingSettingView.vue'),
                  },
                ],
              },
              // Promotion
              {
                path: 'promote',
                name: 'promote',
                component: () => import('@views/promotion/StudentPromotionView.vue'),
              },

              /* SETTINGS */
              {
                path: 'settings',
                name: 'control-panel-settings',
                redirect: {
                  name: 'system',
                },
                component: () => import('@/src/router/layouts/control-panel/settings/layout.vue'),
                children: [],
              },
            ],
          },
          /* APP DOCUMENT */
          {
            path: 'app-documentation',
            name: 'app-documentation',
            component: () => import('@/src/router/layouts/app-document/documentationLayout.vue'),
            redirect: { name: 'fee-documentation' },
            children: [
              {
                path: 'web-document',
                name: 'app-documentation-web-document',
                component: () => import('@/src/router/layouts/app-document/app-document.vue'),
              },
              /* Fee Manager Documentation */
              {
                path: 'fee-documentation',
                name: 'fee-documentation',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/fee-documentation/FeeManager-questions.vue'
                  ),
              },
              {
                path: 'fee/:id',
                name: 'fee-question',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/fee-documentation/feeQuestionAnswer.vue'
                  ),
              },
              /* Syllabus Manager Documentation */
              {
                path: 'syllabus-manager-documentation',
                name: 'syllabus-manager-documentation',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/syllabus-automater-documentation/syllabusManager-questions.vue'
                  ),
              },
              {
                path: 'syllabus/:id',
                name: 'syllabus-question',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/syllabus-automater-documentation/syllabusQuestionAnswer.vue'
                  ),
              },
              /* Exam Planner & Exam Results Documentation */
              {
                path: 'exam-planner-documentation',
                name: 'exam-planner-documentation',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/exam-planner-documentation/examPlanner-questions.vue'
                  ),
              },
              {
                path: 'exam/:id',
                name: 'exam-question',
                component: () =>
                  import(
                    '@/src/router/layouts/app-document/exam-planner-documentation/examQuestionAnswer.vue'
                  ),
              },
            ],
          },
          // Routes related to user settings passes through user setting layout
          {
            path: '/settings/user',
            redirect: { name: 'notification-preferences' },
            component: () => import('@src/router/layouts/setting-layout/setting-layout.vue'),
            children: [
              {
                path: 'perosnal-info',
                name: 'perosnal-info',
                component: () => import('@views/settings/profile-settings/PersonalInformation.vue'),
              },
              {
                path: 'contact-info',
                name: 'contact-info',
                component: () => import('@views/settings/profile-settings/ContactInformation.vue'),
              },
              {
                path: 'professional-info',
                name: 'professional-info',
                component: () =>
                  import('@views/settings/profile-settings/ProfessionalInformation.vue'),
              },
              {
                path: 'salary-info',
                name: 'salary-info',
                component: () => import('@views/settings/profile-settings/SalaryInformation.vue'),
              },
              {
                path: 'change-password',
                name: 'change-password',
                component: () => import('@views/settings/security-settings/ChangePassword.vue'),
              },
              {
                path: 'change-email',
                name: 'change-email',
                component: () => import('@views/settings/security-settings/ChangeEmail.vue'),
              },
              {
                path: 'email',
                name: 'email',
                component: () => import('@views/settings/security-settings/Email.vue'),
              },
              {
                path: 'phone',
                name: 'phone',
                component: () => import('@views/settings/security-settings/Phone.vue'),
              },
              {
                path: 'change-phone',
                name: 'change-phone',
                component: () => import('@views/settings/security-settings/ChangePhone.vue'),
              },
              {
                path: 'theme-settings',
                name: 'theme-settings',
                component: () => import('@views/settings/theme-settings/theme-settings.vue'),
              },
              {
                path: 'notification-preferences',
                name: 'notification-preferences',
                component: () =>
                  import(
                    '@src/router/views/settings/notification-settings/notificationPreferencesView.vue'
                  ),
              },
            ],
          },
          /* Teacher Mode */
          {
            path: '/teacher-mode',
            redirect: { name: 'teacher-profile' },
            component: () =>
              import('@src/router/layouts/teacher-layout/teacher-profile-layout.vue'),
            children: [
              {
                path: 'dashboard',
                name: 'teacher-profile-dashboard',
                component: () => import('@/src/router/views/teacher/profile/DashboardView.vue'),
              },
              {
                path: 'profile',
                name: 'teacher-profile',
                component: () => import('@/src/router/views/teacher/profile/ProfileView.vue'),
              },
              {
                path: 'schedules',
                name: 'teacher-schedules',
                component: () => import('@views/teacher/profile/SchedulesView.vue'),
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: '/owner',
    name: 'owner',
    redirect: { name: 'owner-forget-password' },
    component: () => import('@src/router/layouts/auth/owner-forget-password.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let loggedIn = localStorage.getItem('auth.currentUser') || null
        if (loggedIn)
          next({
            name: redirectRoute,
          })
        else next()
      },
    },
    children: [
      {
        path: 'forget-password',
        name: 'owner-forget-password',
        component: () =>
          import('@src/router/views/auth/owner-forget-password/ForgetPasswordView.vue'),
      },
      {
        path: 'reset-password',
        name: 'owner-reset-password',
        component: () =>
          import('@src/router/views/auth/owner-forget-password/ResetPasswordView.vue'),
      },
    ],
  },
  {
    path: '/user',
    name: 'user',
    redirect: { name: 'user-forget-password' },
    component: () => import('@src/router/layouts/auth/owner-forget-password.vue'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let loggedIn = localStorage.getItem('auth.currentUser') || null
        if (loggedIn)
          next({
            name: redirectRoute,
          })
        else next()
      },
    },
    children: [
      {
        path: 'setup-password',
        name: 'user-setup-password',
        component: () =>
          import('@src/router/views/auth/user-setup-password/SetUserPasswordView.vue'),
      },
      {
        path: 'forget-password',
        name: 'user-forget-password',
        component: () =>
          import('@src/router/views/auth/user-foget-password/ForgetPasswordView.vue'),
      },
      {
        path: 'choose-forget-option',
        name: 'choose-forget-option',
        component: () =>
          import('@src/router/views/auth/user-foget-password/ChooseForgetOptionView.vue'),
      },
      {
        path: 'reset-password',
        name: 'user-reset-password',
        component: () => import('@src/router/views/auth/user-foget-password/ResetPasswordView.vue'),
      },
    ],
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')

        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired,
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'home',
              }
            : {
                ...routeFrom,
              },
        )
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404.vue').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '/:catchAll(.*)',
    redirect: '404',
  },
]
